import { useState, useEffect } from 'react';
import {
    Table,
    Dropdown,
    Row,
    Col,
    Form,
    Button,
    InputGroup,
    Spinner,
} from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { toast } from 'react-toastify';
import { ReactComponent as ReactMoreIcon } from '../../../../assets/icons/more.svg';
import { StyledPageTitle } from '../../../../styles/pageTitle';
import { StyledTh } from '../../PointData/styles';
import FreightRateModal from './FreightRateModal';
import FreightRateHttpService from '../../../../services/http/freight-rate-http';

export default function FreightRate() {
    const [selectedRate, setSelectedRate] = useState({});
    const [term, setTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [freightRates, setFreightRates] = useState<any[]>([]);
    const [isEdit, setIsEdit] = useState(false);

    const getFreightRates = async () => {
        try {
            const response = await FreightRateHttpService.getFreightRates({all: true});

            setFreightRates(response.data.data);
        } catch (error) {
            setFreightRates([]);
        }
    };

    const deleteRate = async (rate: any) => {
        setLoading(true);

        try {
            await FreightRateHttpService.deleteFreightRate(rate.id);

            getFreightRates();

            toast.success('Faixa de frete removida.');
        } catch (error) {
            const err = error as any;
            toast.error(err.message);
        }

        setLoading(false);
    };

    useEffect(() => {
        getFreightRates();
    }, []);

    return (
        <>
            <FreightRateModal
                show={showModal}
                isOpen={setShowModal}
                update={getFreightRates}
                selectedRate={selectedRate}
                isEdit={isEdit}
                onHide={() => {
                    setSelectedRate({});
                    setShowModal(false);
                }}
            />  

            <Row>
                <Col>
                    <StyledPageTitle className="mt-2">
                        Faixas de Frete
                    </StyledPageTitle>
                </Col>

                <Col>
                    <Button
                        className="float-right w-25 m-2"
                        onClick={() => {
                            setIsEdit(false);
                            setShowModal(true);
                        }}
                    >
                        Nova faixa de frete
                    </Button>
                </Col>
            </Row>

            <Row>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <i className="fas fa-search" />
                        </InputGroup.Text>
                    </InputGroup.Prepend>

                    <Form.Control
                        type="text"
                        value={term}
                        onChange={(event) => setTerm(event.target.value)}
                        placeholder="Digite aqui o que procura..."
                    />
                </InputGroup>
            </Row>

            <Row>
                <Table bordered hover size="sm" className="text-center">
                    <thead>
                        <tr>
                            <StyledTh>UF</StyledTh>
                            <StyledTh>Valor Limite</StyledTh>
                            <StyledTh>Taxa de Frete (%)</StyledTh>
                            <StyledTh />
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4}>
                                    <Spinner animation="border" />
                                </td>
                            </tr>
                        ) : (
                            freightRates
                                .filter((item: any) =>
                                    item.stateAcronym
                                        ?.toLowerCase()
                                        .includes(term.toLowerCase()) ||
                                    String(item.valueLimit).includes(term) ||
                                    String(item.rate).includes(term)
                                )
                                .map((item: any, index: number) => (
                                    <tr key={index}>
                                        <td style={{ padding: 10 }}>
                                            <Highlighter
                                                autoEscape
                                                highlightClassName="highlight-term"
                                                searchWords={[term]}
                                                textToHighlight={
                                                    item.stateAcronym || ''
                                                }
                                            />
                                        </td>

                                        <td>
                                            {Number(
                                                item.valueLimit
                                            ).toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL',
                                            })}
                                        </td>

                                        <td>{item.rate}%</td>

                                        <td>
                                            <Dropdown key="left">
                                                <Dropdown.Toggle
                                                    bsPrefix="nexen"
                                                    className="mt-n3 mb-n3"
                                                    as={Button}
                                                    variant="text"
                                                >
                                                    <ReactMoreIcon
                                                        fill="#bdbdbd"
                                                        width="10"
                                                        height="20"
                                                    />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            setSelectedRate(
                                                                item
                                                            );
                                                            setShowModal(true);
                                                            setIsEdit(true);
                                                        }}
                                                    >
                                                        Editar
                                                    </Dropdown.Item>

                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            deleteRate(item);
                                                        }}
                                                    >
                                                        Remover
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))
                        )}
                    </tbody>
                </Table>
            </Row>

            {freightRates.length === 0 && (
                <Col md={12} className="text-center">
                    <strong style={{ color: '#adadad' }}>
                        Sem itens para carregar
                    </strong>
                </Col>
            )}
        </>
    );
}